<template>
	<div class="expired-badge-wrapper">
		<el-badge value="提醒" class="expired-badge" @click.native.stop="openDialog" title="点击可查看详情">
			<span class="expired-date-info">{{ displayEndTime }}</span>
		</el-badge>
	</div>
</template>

<script>
	export default {
		name: 'ExpiredBadgePopover',
		props: {
			endTime: {
				type: String,
				default: ''
			}
		},
		computed: {
			displayEndTime() {
				return this.endTime ? this.endTime.substring(0, 10) : '';
			},
			expiredText() {
				if (!this.endTime) return '';
				const now = new Date();
				const endTime = new Date(this.endTime);
				const diffTime = endTime - now;
				const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
				if (diffDays < 0) {
					return `会员已过期 ${Math.abs(diffDays)} 天`;
				} else if (diffDays === 0) {
					return '会员今天到期';
				} else {
					return `会员还有 ${diffDays} 天到期`;
				}
			}
		},
		methods: {
			openDialog() {
				this.$confirm(`${this.expiredText}，请尽快续费。到期后文件将保留一个月（可下载回本地），一个月后将全部清空。`, '会员到期提醒', {
					confirmButtonText: '立即续费',
					cancelButtonText: '我知道了',
					type: 'warning',
					customClass: 'expired-confirm-dialog'
				})
					.then(() => {
						//跳转到续费页面
						this.$router.push({ path: '/Version' });
					})
					.catch(() => {});
			}
		}
	};
</script>

<style lang="less" scoped>
	.expired-badge-wrapper {
		display: inline-block;
	}

	.expired-badge {
		/deep/ .el-badge__content {
			top: 1px;
			right: 2px;
			cursor: pointer;
		}
	}

	.expired-date-info {
		font-size: 13px;
		color: #64748b;
		cursor: pointer;

		&:hover {
			color: #2563eb;
		}
	}
</style>
